import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconBathWoman1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBathWoman1"><Circle cx="12" cy="4" r="2.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 22.5V19H18L15.5 8.5H8.5L6 19H8.5V22.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBathWoman1;
